import React from "react"
import ToastNotification from "./ToastNotification"

export interface ToastSuccessProps {
  message: string
}

const ToastSuccess: React.FC<ToastSuccessProps> = ({ message }) => (
  <ToastNotification message={message} type="success" />
)

export default ToastSuccess
